module.exports = __webpack_public_path__ + "f9eced25.svg";